// tslint:disable:max-line-length
import { IconProps } from 'components/Shared/Icon/index';
import { iconStyles } from 'components/Shared/Icon/iconStyles';

// tslint:disable: max-line-length
export const IconCaret = (props: IconProps) => (
  <svg viewBox="0 0 7 11" xmlns="http://www.w3.org/2000/svg" className={iconStyles(props)}>
    <path
      d="M1.35273 0.487793L0.177734 1.66279L3.9944 5.48779L0.177734 9.31279L1.35273 10.4878L6.35273 5.48779L1.35273 0.487793Z"
      stroke="none"
    />
  </svg>
);
